import { h, Transition } from 'vue';
import { createComponent } from './utils/create-component';

var _createComponent = createComponent('transition'),
  create = _createComponent.create;
var script = create({
  setup: function setup(props, context) {
    return function () {
      return h(Transition, context.attrs, context.slots);
    };
  }
});

script.__file = "components/src/component/transition/transition.vue";

/*
 * @Description: Transition 组件导出文件
 * @Author: duqiao@kuaishou.com
 * @Date: 2022-03-04 11:25:59
 * @LastEditors: zhoushichao@kuaishou.com
 * @LastEditTime: 2023-02-02 11:24:56
 */
var _Transition = script;

export { _Transition as default };
